import React from "react";
import { ZoomIn, ZoomOut, Maximize2, GitBranchPlus } from "lucide-react";

export function GraphToolbar({ rfInstance, state }) {
  const btn =
    "w-10 h-10 flex items-center justify-center text-[#14140f]/70 hover:text-[#14140f] hover:bg-[#f5f4f0] transition-colors duration-150";

  return (
    <div
      className="absolute left-4 bottom-4 z-10 flex flex-col rounded-xl overflow-hidden bg-[#fdfdfb]/90 backdrop-blur-md border border-[#14140f]/10 shadow-md divide-y divide-[#14140f]/10"
      data-testid="graph-toolbar"
    >
      <button className={btn} title="Zoom in" data-testid="graph-zoom-in" onClick={() => rfInstance?.zoomIn({ duration: 250 })}>
        <ZoomIn className="w-4 h-4" />
      </button>
      <button className={btn} title="Zoom out" data-testid="graph-zoom-out" onClick={() => rfInstance?.zoomOut({ duration: 250 })}>
        <ZoomOut className="w-4 h-4" />
      </button>
      <button className={btn} title="Fit view" data-testid="graph-fit-view" onClick={() => rfInstance?.fitView({ duration: 400, padding: 0.2 })}>
        <Maximize2 className="w-4 h-4" />
      </button>
      <button
        className={btn}
        title="Expand selected node"
        data-testid="graph-expand-selected"
        onClick={() => state.expand(state.selectedId || state.rootId)}
      >
        <GitBranchPlus className="w-4 h-4" />
      </button>
    </div>
  );
}
